export default {
      id: "unit_type_reefer-usage",
      viewBox: "0 0 37 19",
      url: __webpack_public_path__ + "img/icons.svg#unit_type_reefer",
      toString: function () {
        return this.url;
      }
    }